export function isValidParam(value: string | null): value is string {
  return !!value && value !== 'undefined' && value !== 'null';
}